export const legal = {
	disclaimer: {
		title: "Disclaimer",
		lastUpdated: "Last Updated",
		sections: {
			siteInfo: {
				title: "Article 1 (About Information on This Site)",
				content: "We strive to provide accurate information on this site, but misinformation may be included or information may become outdated.\nWe cannot be held responsible for any damages caused by the content posted on this site.",
			},
			appUsage: {
				title: "Article 2 (About Application Usage)",
				content: "We assume no responsibility for any damages arising from the use of applications developed and provided by us.\nDownloading, installing, and using applications is at the user's own risk.",
			},
			links: {
				title: "Article 3 (About Links)",
				content: "We assume no responsibility for information or services provided on destination sites when you move to other sites via links or banners from this site.",
			},
			technicalIssues: {
				title: "Article 4 (About Technical Issues)",
				content: "This site and applications may suspend services without notice due to system maintenance, server failures, or other reasons.\nWe assume no responsibility for damages caused by such service suspensions.",
			},
			thirdPartyServices: {
				title: "Article 5 (About Third-Party Services)",
				content: "This site and applications may use third-party services (advertising, analytics, etc.).\nWe assume no responsibility for damages caused by the use of these third-party services.",
			},
			copyright: {
				title: "Article 6 (About Copyright and Intellectual Property Rights)",
				content: "Copyrights and other intellectual property rights of content (text, images, videos, audio, programs, etc.) provided on this site belong to us or legitimate third parties.\nUnauthorized reproduction, modification, or distribution of these is prohibited.",
			},
			limitation: {
				title: "Article 7 (Limitation of Liability for Damages)",
				content: "We assume no responsibility for damages incurred by users in connection with the use of this site and applications, except in cases of our intentional or gross negligence.",
			},
			changes: {
				title: "Article 8 (Changes to Disclaimer)",
				content: "We may change this disclaimer without prior notice to users.\nThe revised disclaimer shall become effective when posted on this site.",
			},
			contact: {
				title: "Contact",
				content: "For inquiries regarding this disclaimer, please contact us at:",
			},
		},
		contactSection: {
			emailButton: "Contact via Email",
		},
	},

	termsOfService: {
		title: "Terms of Service",
		lastUpdated: "Last Updated",
		sections: {
			application: {
				title: "Article 1 (Application)",
				content: "These Terms define the conditions of use for applications and services (hereinafter referred to as \"the Service\") provided by Kazumasa Shimomura (hereinafter referred to as \"we\" or \"us\").\nUsers (hereinafter referred to as \"User\" or \"Users\") shall use the Service in accordance with these Terms.",
			},
			registration: {
				title: "Article 2 (User Registration)",
				content: "1. Those who wish to register for the Service shall apply for registration by the method specified by us, and registration shall be completed when we approve the application.\n\n2. We may not approve registration applications in the following cases, and we have no obligation to disclose the reasons:\n  • When false information is provided in the registration application\n  • When the application is from a person who has violated these Terms\n  • When we determine that registration is inappropriate",
			},
			prohibited: {
				title: "Article 3 (Prohibited Acts)",
				content: "Users shall not engage in the following acts when using the Service:\n\n1. Acts that violate laws or public order and morals\n2. Acts related to criminal activities\n3. Acts that destroy or interfere with the functions of our servers or networks, other users' servers or networks, or those of third parties\n4. Acts that may interfere with the operation of our Service\n5. Acts of collecting or accumulating personal information about other users\n6. Acts of unauthorized access or attempts thereof\n7. Acts of impersonating other users\n8. Acts of directly or indirectly providing benefits to antisocial forces in connection with our Service\n9. Acts that infringe upon the intellectual property rights, portrait rights, privacy, honor, or other rights or interests of us, other users, or other third parties\n10. Other acts deemed inappropriate by us",
			},
			suspension: {
				title: "Article 4 (Suspension of Service Provision)",
				content: "1. We may suspend or interrupt all or part of the Service without prior notice to users if any of the following reasons are deemed to exist:\n  • When performing maintenance or updates of computer systems related to the Service\n  • When provision of the Service becomes difficult due to force majeure such as earthquakes, lightning, fire, power outages, or natural disasters\n  • When computers or communication lines stop due to accidents\n  • When we determine that provision of the Service is difficult\n\n2. We assume no responsibility for any disadvantages or damages suffered by users or third parties due to the suspension or interruption of the Service.",
			},
			termination: {
				title: "Article 5 (Use Restrictions and Registration Deletion)",
				content: "1. We may, without prior notice, restrict all or part of a user's use of the Service or delete the user's registration if the user falls under any of the following:\n  • When any provision of these Terms is violated\n  • When it is discovered that there are false facts in the registered information\n  • When we determine that use of the Service is inappropriate\n\n2. We assume no responsibility for damages incurred by users due to actions taken by us based on this article.",
			},
			warranty: {
				title: "Article 6 (Disclaimer of Warranties and Limitation of Liability)",
				content: "1. We do not expressly or implicitly guarantee that the Service is free from defects (including defects in safety, reliability, accuracy, completeness, effectiveness, fitness for a particular purpose, security, errors or bugs, infringement of rights, etc.).\n\n2. We assume no responsibility for any damages incurred by users arising from the Service, except in cases of our intentional or gross negligence.\n\n3. Even in the cases specified in the proviso of the preceding paragraph, we assume no responsibility for damages arising from special circumstances (including cases where we or the user foresaw or could have foreseen the occurrence of damage) among damages incurred by users due to breach of contract or tort caused by our negligence (excluding gross negligence).\n\n4. We assume no responsibility for transactions, communications, or disputes that arise between users and other users or third parties regarding the Service.",
			},
			serviceChange: {
				title: "Article 7 (Changes to Service Content)",
				content: "We may change, add to, or discontinue the content of the Service with prior notice to users, and users consent to this.",
			},
			termsChange: {
				title: "Article 8 (Changes to Terms of Service)",
				content: "1. We may change these Terms without individual consent from users in the following cases:\n  • When the change to these Terms is in the general interest of users\n  • When the change to these Terms does not contradict the purpose of the service use agreement and is reasonable in light of the necessity of the change, the appropriateness of the content after the change, and other circumstances related to the change\n\n2. We shall notify users in advance of the change to these Terms, the content of the Terms after the change, and the effective date when changing these Terms pursuant to the preceding paragraph.",
			},
			privacy: {
				title: "Article 9 (Handling of Personal Information)",
				content: "We shall appropriately handle personal information obtained through the use of the Service in accordance with our \"Privacy Policy.\"",
			},
			notification: {
				title: "Article 10 (Notices or Communications)",
				content: "Notices or communications between users and us shall be made by the method specified by us.\nWe shall consider the currently registered contact information as valid and send notices or communications to that contact information unless we receive a change notification from the user in accordance with the format separately specified by us, and these shall be deemed to have reached the user at the time of transmission.",
			},
			assignment: {
				title: "Article 11 (Prohibition of Assignment of Rights and Obligations)",
				content: "Users may not assign their position under the service agreement or rights or obligations under these Terms to third parties or pledge them as collateral without our prior written consent.",
			},
			jurisdiction: {
				title: "Article 12 (Governing Law and Jurisdiction)",
				content: "1. Japanese law shall be the governing law for the interpretation of these Terms.\n\n2. In the event of any dispute regarding the Service, the court having jurisdiction over our location shall be the exclusive agreed jurisdiction.",
			},
			contact: {
				title: "Contact",
				content: "For inquiries regarding these Terms, please contact us at:",
			},
		},
		contactSection: {
			emailButton: "Contact via Email",
		},
	},

	privacyPolicy: {
		title: "Privacy Policy",
		lastUpdated: "Last Updated",
		intro: "Kazumasa Shimomura (hereinafter referred to as \"Operator\") has established the following Privacy Policy (hereinafter referred to as \"this Policy\") regarding the handling of users' personal information in the applications provided by the Operator (hereinafter referred to as \"this App\").",
		sections: {
			collection: {
				title: "1. Collection of Personal Information",
				content: "This App may collect the following information:\n\n• Device information (OS, device type, language settings, etc.)\n• App usage data (frequency of use, feature usage, etc.)\n• Crash report information\n• Advertising identifier (IDFA/AAID)\n\nThis information is collected for the purpose of improving app quality, fixing bugs, and enhancing user experience.",
			},
			usage: {
				title: "2. Purpose of Use of Personal Information",
				content: "The collected information is used for the following purposes:\n\n• Provision, operation, and improvement of the app\n• Investigation and correction of bugs\n• Provision of user support\n• Creation of statistical data\n• Development and improvement of new features\n• Delivery and measurement of advertising effectiveness",
			},
			thirdParty: {
				title: "3. Use of Third-Party Services",
				content: "This website and the App use the following third-party services:\n\n【Advertising Services】\n• Google AdMob\nDetails: https://policies.google.com/privacy\n\n【Analytics Services】\n• Google Analytics (this website)\nDetails: https://policies.google.com/privacy\n\n• Google Analytics for Firebase (the App)\nDetails: https://firebase.google.com/support/privacy\n\n• Crashlytics\nDetails: https://firebase.google.com/support/privacy\n\nThese services collect and use information based on their own privacy policies.",
			},
			disclosure: {
				title: "4. Disclosure of Personal Information to Third Parties",
				content: "The Operator will not provide users' personal information to third parties except in the following cases:\n\n• When there is consent from the user\n• When required by law\n• When it is necessary to protect the life, body, or property of a person and it is difficult to obtain the consent of the person\n• When it is necessary to cooperate with a national institution, local government, or a person entrusted by them in carrying out affairs prescribed by laws and regulations",
			},
			security: {
				title: "5. Security of Personal Information",
				content: "The Operator takes all possible security measures to ensure the accuracy and safety of personal information. However, we do not guarantee the complete security of communications via the Internet.",
			},
			rights: {
				title: "6. User Rights",
				content: "Users can request disclosure, correction, or deletion of their personal information. You can also reset your advertising identifier or limit ad tracking from your OS settings.\n\niOS: Settings > Privacy & Security > Tracking\nAndroid: Settings > Google > Ads",
			},
			dataRetention: {
				title: "7. Data Retention Period",
				content: "Collected data is retained only for the period necessary to achieve the purpose of use. By uninstalling the app, data on the device will be deleted. However, data sent to analytics services, etc., will be subject to the policies of each service.",
			},
			children: {
				title: "8. Children's Privacy",
				content: "This App is not intended for children under the age of 13. The Operator does not intentionally collect personal information from children under 13.",
			},
			changes: {
				title: "9. Changes to Privacy Policy",
				content: "The contents of this Policy may be changed without notice to users, except for matters separately stipulated in laws and regulations or in this Policy. The revised Privacy Policy shall become effective when posted on this page.",
			},
			contact: {
				title: "10. Contact",
				content: "For inquiries regarding this Policy, please contact us at:",
			},
		},
		contactSection: {
			emailButton: "Contact via Email",
			responseNote: "* It may take a few days to respond",
		},
	},

	commercialLaw: {
		title: "Specified Commercial Transaction Act",
		lastUpdated: "Last Updated",
		table: {
			seller: "Business Operator",
			operator: "Operator",
			address: "Address",
			contact: "Contact",
			price: "Price",
			additionalFees: "Additional Fees",
			paymentMethod: "Payment Method",
			paymentTiming: "Payment Timing",
			deliveryTiming: "Delivery Timing",
			returnPolicy: "Return Policy",
			serviceValidity: "Service Validity",
			requirements: "Requirements",
		},
		values: {
			sellerName: "Kazumasa Shimomura",
			operatorName: "Kazumasa Shimomura",
			addressDisclosure: "Will be disclosed promptly upon request",
			contactEmailLabel: "Email",
			contactNote: "* Please contact us via email",
			priceNote: "Displayed in each application\niOS: Displayed as In-App Purchase in the App Store\nAndroid: Displayed as In-App Purchase in Google Play",
			additionalFeesNote: "Internet connection fees and communication fees are borne by the customer",
			paymentMethodNote: "iOS: App Store payment (via Apple ID)\nAndroid: Google Play payment (via Google account)\n* Details are subject to each store's payment terms",
			paymentTimingNote: "Immediate payment at the time of purchase",
			deliveryTimingNote: "Available immediately after payment is completed",
			returnPolicyNote: "Due to the nature of digital content, returns and exchanges are not accepted in principle.\nHowever, this does not apply if there are serious defects in the application.\nRefunds are subject to each store's (Apple/Google) refund policy.",
			serviceValidityNote: "For subscriptions: According to the purchase period\nFor one-time purchases: Indefinite (until service termination)",
			requirementsNote: "iOS: iOS 17.0 or later (may vary depending on the app)\nAndroid: Android 7.0 or later (may vary depending on the app)\nPlease check each app's store page for details",
		},
		notes: {
			title: "Notes",
			items: [
				"This information relates to in-app purchases provided via the App Store and Google Play.",
				"All payments are made through Apple's or Google's system.",
				"The price displayed on each store is the official selling price.",
				"Prices may change due to exchange rate fluctuations, etc.",
			],
		},
		contactSection: {
			title: "Contact",
			description: "For inquiries about products and services, please contact us at:",
			emailButton: "Contact via Email",
			responseNote: "* It may take a few days to respond",
		},
	},
} as const;
